import React, { useState, useEffect } from "react";
import grey from "@material-ui/core/colors/grey";
import StopSharpIcon from "@material-ui/icons/StopSharp";
import PropTypes from "prop-types";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from "@material-ui/core/Button";
import moment from 'moment';
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import clsx from "clsx";
import Box from "@material-ui/core/Box";
import {
  FormHelperText,
  Input,
  InputLabel,
  InputBase,
} from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Checkbox from "@material-ui/core/Checkbox";
import {
  DatePicker, KeyboardDatePicker
} from '@material-ui/pickers';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import { reportFilterSample } from "./ReportObj"
import { sampleFilterLube } from "./ReportObj"
import { ToastError } from "../../services/ToastMsg";
import { getCookie } from "../../services/Cookies";
import FilterComponents from "../FilterComponents/FilterComponents";
import { FilterComponentObj } from "../FilterComponents/FilterComponentObj";
import { getCurrentDate, getCurrentDateOfBelow, getDefaultFuelDate, getDefaultLubeDate, getDefaultTotDate } from "../../services/DateServices";

const useStyles = makeStyles((theme) => ({
  justifyContentBetween: {
    justifyContent: "space-between!important",
  },
  alignItemsStretch: {
    alignItems: "stretch",
  },
  borderRight: {
    borderRight: "1px solid " + grey[400],
  },
  MuiButtonBaseRoot: {
    borderRadius: 4,
    padding: 0,
    paddingBottom: "2px",
    color: grey[400],
  },
  MuiSvgIconRoot: {
    color: "#ff4717",
    border: "2px solid " + grey[400],
    fontSize: "1.3rem",
    borderRadius: 3,
  },
  anchorTag: {
    textDecoration: "none",
    cursor: "pointer",
  },
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight: "8px"
  },
}));
const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },

  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "auto",
    padding: "10px 12px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);

const BootstrapDate = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },

  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "100%",
    padding: "10px 12px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);
export default function FiltersSampleLube(props) {
  const classes = useStyles();
  const [filter, setFilter] = React.useState(true);
  const [selectedStartDate, handleStartChange] = useState(new Date());
  const [selectedEndDate, handleEndChange] = useState(new Date());
const[resetdate,setresetdate]=React.useState("");
  const [formObj, setFormObj] = useState(sampleFilterLube);
  const [selectedValue, setSelectedValue] = React.useState('All');
  const [filtercomObj, setfiltercomObj] = React.useState(FilterComponentObj);
  const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));

  const { filterSampleLube, clearFilter,FormatClearFilter } = props;

  const onChangeText = (event) => {
    setFormObj({ ...formObj, [event.target.name]: event.target.value });
    ////console.log(formObj);

  };
  const handleDateData = (event, type) => {
    let dateFormat = "";
    if (event) {
      dateFormat = event.format('YYYY-MM-DD');
    }
    setFormObj({ ...formObj, [type]: dateFormat });
    // ////console.log(event, type);
  }
  const applyFilter = (Obj) => {
    //
    filterSampleLube(Obj);
    FormatClearFilter(Obj)
    //filterSampleLube(formObj);

  };
  const onClearFilter = (Obj) => {
    if (getCookie('historicvessels') === 'true') {
      Obj = { ...Obj, HistoricVessel: true}
      //setFormObj({ ...formObj, HistoricVessel: true }) ;
    } else {
      Obj = { ...Obj, HistoricVessel: false }
      //setFormObj({ ...formObj, HistoricVessel: false }) ;
    }

    filterSampleLube(Obj);
    props.OnResetValue()
    FormatClearFilter(Obj)
    //props.IntialLubeLoadEffect()
    //setFormObj(sampleFilterLube);
    let date = getDefaultLubeDate();
    setresetdate(date);
    //clearFilter();
  }
  const enterKey = (event) => {
    if (event.key === 'Enter') {
      applyFilter()
    } if (event.key === 'Escape') {
      onClearFilter()
    }
  }
  
  const shipnameparent = (newValue) => {
    //
    setfiltercomObj({ ...filtercomObj, shipNameImokey: newValue })
  }
  const LoBrandnameparent = (newValue) => {
    //
    setfiltercomObj({ ...filtercomObj, lobrand: newValue })
  }
  const LoGradenameparent = (newValue) => {
    //
    setfiltercomObj({ ...filtercomObj, lograde: newValue })
  }
  const LubeEquipnameparent = (newValue) => {
    //
    setfiltercomObj({ ...filtercomObj, lubeequipname: newValue })
  }
  const LubeMakenameparent = (newValue) => {
    //
    setfiltercomObj({ ...filtercomObj, lubeequipmake: newValue })
  }
  const LubeModelnameparent = (newValue) => {
    //
    setfiltercomObj({ ...filtercomObj, lubeequipmodel: newValue })
  }
  const LubeReportDatenameparent = (newValue) => {
    //
    setfiltercomObj({ ...filtercomObj, lubereportstartdate: newValue, lubereportenddate: newValue })


  }
  const LubeSampledDatenameparent = (newValue) => {
    //
    setfiltercomObj({ ...filtercomObj, lubesamplestartdate: newValue, lubesampleenddate: newValue })


  }
  const defaultValue = (val) => {
    //
    if (val !== "" && val !== undefined && val !== "null") {
      let Obj = JSON.parse(val);
      setfiltercomObj(Obj);
      console.log('getcookievalue', formObj)
    }
  }
  React.useEffect(() => {
    //fetchShipNameData();
    defaultValue(GlobalFilterSettingValue);
  }, []);
  return (
    <div>
      <Box className="decarbox1" component="div" style={{ padding: "20px" }}  >
        <FilterComponents screen={'samples'} defaultDate={props.defaultDate} filtervalue={["CustomerName", "ShipName_imo", "LoBrand", "LoGrade", "EquipName", "EquipMake", "EquipModel", "Service_type", "LubeSampleDateComponent", "Lab_Lube"]} applyFilter={applyFilter} reset={onClearFilter} />
      </Box>

    </div>
  );
}

